/**
 * @generated SignedSource<<6022bdd19aaafa4258b0507b4b077475>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDetailInfoItems_todo$data = {
  readonly assignedUsers: ReadonlyArray<{
    readonly user: {
      readonly name: string;
    } | null;
  }>;
  readonly assigneeText: string;
  readonly createdBy: {
    readonly name: string;
  } | null;
  readonly expireAt: string | null;
  readonly " $fragmentType": "TodoDetailInfoItems_todo";
};
export type TodoDetailInfoItems_todo$key = {
  readonly " $data"?: TodoDetailInfoItems_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailInfoItems_todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDetailInfoItems_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assigneeText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoAssignedUser",
      "kind": "LinkedField",
      "name": "assignedUsers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "9fa9c0b51004f9d8932586df7c70388a";

export default node;
